export default {
  name: 'Address',
  edit: {
    form: 'description-input',
    label: 'Edit Address',
    handler: value => value,
  },
};
